import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export type StatoServizio = "ok" | "warn" | "err" | "sconosciuto";

export interface SaluteKpi {
  email_oggi: number;
  in_errore: number;
  bloccate: number;
  richieste_dati_pendenti: number;
  tempo_medio_risposta_s: number | null;
  costo_ai_7gg_usd: number;
  ai_chiamate_7gg: number;
}

export interface ServizioCard {
  id: string;
  titolo: string;
  stato: StatoServizio;
  sottotitolo: string;
  meta: string;
}

export interface AgenteSalute {
  kpi: SaluteKpi;
  servizi: ServizioCard[];
}

export function useAgenteSalute(slug: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["admin", "agente", slug, "salute"],
    queryFn: () => apiFetch<AgenteSalute>(`/api/v1/admin/agenti/${slug}/salute`),
    enabled: !!slug && enabled,
  });
}
